import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MuContextSettings } from '../shared/types/contextSettings.type';
import { HttpClient } from '@angular/common/http';

import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from '../shared/sharedComponents/shared.module';
import { CediStoreRoutingModule } from './cedi-store-routing.module';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { MapLeafletModule } from '../shared/sharedComponents/map-leaflet/map-leaflet.module';
import { SelectButtonModule } from 'primeng/selectbutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { LoadStoreComponent } from './pages/load-store/load-store.component';
import { ListCediComponent } from './pages/list-cedi/list-cedi.component';
// import { GMapModule } from 'primeng/gmap';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AddressCardComponent } from './sharedComponents/address-card/address-card.component';

@NgModule({
  declarations: [LoadStoreComponent, ListCediComponent, AddressCardComponent],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: MuContextSettings.language(''),
        deps: [HttpClient],
      },
      isolate: true,
    }),
    CommonModule,
    FormsModule,
    // GMapModule,
    LayoutModule,
    SharedModule,
    ButtonModule,
    TabViewModule,
    ToastModule,
    TableModule,
    DialogModule,
    FileUploadModule,
    MapLeafletModule,
    CediStoreRoutingModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    AutoCompleteModule,
  ],
})
export class CediStoreModule {}
